export interface ThaiProvince {
  value: string
  labelTh: string
  labelEn: string
}

// All 77 Thai provinces, sorted alphabetically by Thai name.
// The `value` field stores the Thai name as used in the database.
export const THAI_PROVINCES: ThaiProvince[] = [
  { value: 'กระบี่', labelTh: 'กระบี่', labelEn: 'Krabi' },
  { value: 'กรุงเทพมหานคร', labelTh: 'กรุงเทพมหานคร', labelEn: 'Bangkok' },
  { value: 'กาญจนบุรี', labelTh: 'กาญจนบุรี', labelEn: 'Kanchanaburi' },
  { value: 'กาฬสินธุ์', labelTh: 'กาฬสินธุ์', labelEn: 'Kalasin' },
  { value: 'กำแพงเพชร', labelTh: 'กำแพงเพชร', labelEn: 'Kamphaeng Phet' },
  { value: 'ขอนแก่น', labelTh: 'ขอนแก่น', labelEn: 'Khon Kaen' },
  { value: 'จันทบุรี', labelTh: 'จันทบุรี', labelEn: 'Chanthaburi' },
  { value: 'ฉะเชิงเทรา', labelTh: 'ฉะเชิงเทรา', labelEn: 'Chachoengsao' },
  { value: 'ชลบุรี', labelTh: 'ชลบุรี', labelEn: 'Chonburi' },
  { value: 'ชัยนาท', labelTh: 'ชัยนาท', labelEn: 'Chainat' },
  { value: 'ชัยภูมิ', labelTh: 'ชัยภูมิ', labelEn: 'Chaiyaphum' },
  { value: 'ชุมพร', labelTh: 'ชุมพร', labelEn: 'Chumphon' },
  { value: 'เชียงราย', labelTh: 'เชียงราย', labelEn: 'Chiang Rai' },
  { value: 'เชียงใหม่', labelTh: 'เชียงใหม่', labelEn: 'Chiang Mai' },
  { value: 'ตรัง', labelTh: 'ตรัง', labelEn: 'Trang' },
  { value: 'ตราด', labelTh: 'ตราด', labelEn: 'Trat' },
  { value: 'ตาก', labelTh: 'ตาก', labelEn: 'Tak' },
  { value: 'นครนายก', labelTh: 'นครนายก', labelEn: 'Nakhon Nayok' },
  { value: 'นครปฐม', labelTh: 'นครปฐม', labelEn: 'Nakhon Pathom' },
  { value: 'นครพนม', labelTh: 'นครพนม', labelEn: 'Nakhon Phanom' },
  { value: 'นครราชสีมา', labelTh: 'นครราชสีมา', labelEn: 'Nakhon Ratchasima' },
  { value: 'นครศรีธรรมราช', labelTh: 'นครศรีธรรมราช', labelEn: 'Nakhon Si Thammarat' },
  { value: 'นครสวรรค์', labelTh: 'นครสวรรค์', labelEn: 'Nakhon Sawan' },
  { value: 'นนทบุรี', labelTh: 'นนทบุรี', labelEn: 'Nonthaburi' },
  { value: 'นราธิวาส', labelTh: 'นราธิวาส', labelEn: 'Narathiwat' },
  { value: 'น่าน', labelTh: 'น่าน', labelEn: 'Nan' },
  { value: 'บึงกาฬ', labelTh: 'บึงกาฬ', labelEn: 'Bueng Kan' },
  { value: 'บุรีรัมย์', labelTh: 'บุรีรัมย์', labelEn: 'Buriram' },
  { value: 'ปทุมธานี', labelTh: 'ปทุมธานี', labelEn: 'Pathum Thani' },
  { value: 'ประจวบคีรีขันธ์', labelTh: 'ประจวบคีรีขันธ์', labelEn: 'Prachuap Khiri Khan' },
  { value: 'ปราจีนบุรี', labelTh: 'ปราจีนบุรี', labelEn: 'Prachinburi' },
  { value: 'ปัตตานี', labelTh: 'ปัตตานี', labelEn: 'Pattani' },
  { value: 'พระนครศรีอยุธยา', labelTh: 'พระนครศรีอยุธยา', labelEn: 'Phra Nakhon Si Ayutthaya' },
  { value: 'พะเยา', labelTh: 'พะเยา', labelEn: 'Phayao' },
  { value: 'พังงา', labelTh: 'พังงา', labelEn: 'Phang Nga' },
  { value: 'พัทลุง', labelTh: 'พัทลุง', labelEn: 'Phatthalung' },
  { value: 'พิจิตร', labelTh: 'พิจิตร', labelEn: 'Phichit' },
  { value: 'พิษณุโลก', labelTh: 'พิษณุโลก', labelEn: 'Phitsanulok' },
  { value: 'เพชรบุรี', labelTh: 'เพชรบุรี', labelEn: 'Phetchaburi' },
  { value: 'เพชรบูรณ์', labelTh: 'เพชรบูรณ์', labelEn: 'Phetchabun' },
  { value: 'แพร่', labelTh: 'แพร่', labelEn: 'Phrae' },
  { value: 'ภูเก็ต', labelTh: 'ภูเก็ต', labelEn: 'Phuket' },
  { value: 'มหาสารคาม', labelTh: 'มหาสารคาม', labelEn: 'Maha Sarakham' },
  { value: 'มุกดาหาร', labelTh: 'มุกดาหาร', labelEn: 'Mukdahan' },
  { value: 'แม่ฮ่องสอน', labelTh: 'แม่ฮ่องสอน', labelEn: 'Mae Hong Son' },
  { value: 'ยโสธร', labelTh: 'ยโสธร', labelEn: 'Yasothon' },
  { value: 'ยะลา', labelTh: 'ยะลา', labelEn: 'Yala' },
  { value: 'ร้อยเอ็ด', labelTh: 'ร้อยเอ็ด', labelEn: 'Roi Et' },
  { value: 'ระนอง', labelTh: 'ระนอง', labelEn: 'Ranong' },
  { value: 'ระยอง', labelTh: 'ระยอง', labelEn: 'Rayong' },
  { value: 'ราชบุรี', labelTh: 'ราชบุรี', labelEn: 'Ratchaburi' },
  { value: 'ลพบุรี', labelTh: 'ลพบุรี', labelEn: 'Lopburi' },
  { value: 'ลำปาง', labelTh: 'ลำปาง', labelEn: 'Lampang' },
  { value: 'ลำพูน', labelTh: 'ลำพูน', labelEn: 'Lamphun' },
  { value: 'เลย', labelTh: 'เลย', labelEn: 'Loei' },
  { value: 'ศรีสะเกษ', labelTh: 'ศรีสะเกษ', labelEn: 'Si Sa Ket' },
  { value: 'สกลนคร', labelTh: 'สกลนคร', labelEn: 'Sakon Nakhon' },
  { value: 'สงขลา', labelTh: 'สงขลา', labelEn: 'Songkhla' },
  { value: 'สตูล', labelTh: 'สตูล', labelEn: 'Satun' },
  { value: 'สมุทรปราการ', labelTh: 'สมุทรปราการ', labelEn: 'Samut Prakan' },
  { value: 'สมุทรสงคราม', labelTh: 'สมุทรสงคราม', labelEn: 'Samut Songkhram' },
  { value: 'สมุทรสาคร', labelTh: 'สมุทรสาคร', labelEn: 'Samut Sakhon' },
  { value: 'สระแก้ว', labelTh: 'สระแก้ว', labelEn: 'Sa Kaeo' },
  { value: 'สระบุรี', labelTh: 'สระบุรี', labelEn: 'Saraburi' },
  { value: 'สิงห์บุรี', labelTh: 'สิงห์บุรี', labelEn: 'Sing Buri' },
  { value: 'สุโขทัย', labelTh: 'สุโขทัย', labelEn: 'Sukhothai' },
  { value: 'สุพรรณบุรี', labelTh: 'สุพรรณบุรี', labelEn: 'Suphan Buri' },
  { value: 'สุราษฎร์ธานี', labelTh: 'สุราษฎร์ธานี', labelEn: 'Surat Thani' },
  { value: 'สุรินทร์', labelTh: 'สุรินทร์', labelEn: 'Surin' },
  { value: 'หนองคาย', labelTh: 'หนองคาย', labelEn: 'Nong Khai' },
  { value: 'หนองบัวลำภู', labelTh: 'หนองบัวลำภู', labelEn: 'Nong Bua Lamphu' },
  { value: 'อ่างทอง', labelTh: 'อ่างทอง', labelEn: 'Ang Thong' },
  { value: 'อำนาจเจริญ', labelTh: 'อำนาจเจริญ', labelEn: 'Amnat Charoen' },
  { value: 'อุดรธานี', labelTh: 'อุดรธานี', labelEn: 'Udon Thani' },
  { value: 'อุตรดิตถ์', labelTh: 'อุตรดิตถ์', labelEn: 'Uttaradit' },
  { value: 'อุทัยธานี', labelTh: 'อุทัยธานี', labelEn: 'Uthai Thani' },
  { value: 'อุบลราชธานี', labelTh: 'อุบลราชธานี', labelEn: 'Ubon Ratchathani' },
]
